import React, { useContext, useState } from 'react';

const ApplicationContext = React.createContext();

export function useApp() {
  return useContext(ApplicationContext);
}
// const showDevModeToast = localStorage.getItem('chronos-devhidden')
//   ? false
//   : true;
const showDevModeToast = false;
export function AppProvider({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarProps, setSidebarProps] = useState(null);
  const [eventPopupOpen, setEventPopupOpen] = useState(false);
  const [popupProps, setPopupProps] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [user, setUser] = useState(null);
  const [showDevToast, setShowDevToast] = useState(showDevModeToast);
  const [releaseMode, setReleaseMode] = useState('ALPHA');

  const openSidebar = (props) => {
    setSidebarProps({ props });
    setSidebarOpen(true);
  };

  const closeSidebar = (clear = true) => {
    if (clear) {
      setSidebarProps(null);
    }
    setSidebarOpen(false);
  };

  const openPopup = (props) => {
    setPopupProps(props);
    setEventPopupOpen(true);
  };

  const closePopup = (clear = true) => {
    setEventPopupOpen(false);
    if (clear) {
      setPopupProps(null);
    }
  };

  const closeAll = () => {
    setEventPopupOpen(false);
    setSidebarOpen(false);
    setPopupProps(null);
    setSidebarProps(null);
  };

  const disableDevToast = () => {
    localStorage.setItem('chronos-devhidden', 'true');
    setShowDevToast(false);
  };

  const value = {
    sidebarOpen,
    setSidebarOpen,
    eventPopupOpen,
    setEventPopupOpen,
    sidebarProps,
    setSidebarProps,
    popupProps,
    setPopupProps,
    editMode,
    setEditMode,
    openSidebar,
    closeSidebar,
    openPopup,
    closePopup,
    closeAll,
    user,
    setUser,
    releaseMode,
    showDevToast,
    setShowDevToast,
    disableDevToast,
  };

  return (
    <ApplicationContext.Provider value={value}>
      {children}
    </ApplicationContext.Provider>
  );
}
